import Axios from 'utils/axios'

export default {
	namespaced: true,
	state:{
		list: [],
		condition:{},
		page: 1,
		pageSize: 10,
		total: 0
	},
	mutations: {
		update(state, payload){
			Object.assign(state, payload)
		}
	},
	actions: {
		fetch({commit, state}, {options = {}}){
			const promise = Axios.get('/admin/report/list', {
				params:{
					...state.condition,
					report_id: 1902,
					page: state.page,
					page_size: state.pageSize
				}
			})
			promise.then(function (res) {
				const data = res[0]
				commit('update', {
					list: data.rows||[],
					total: data.count || 0
				})
			})
			return promise
		}
	}
}
